import moment from "moment";

import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { PrintInfo } from "@/Portfolio/Models/PrintInfo";

import stylesImport from "./MedicalRequestPopupController.module.scss";
import legacyStylesImport from "./MedicalRequestPopupControllerLegacy.module.scss";

interface IMedicalRequestHeaderComponentProps {
    model: PrintInfo;
}

class MedicalRequestHeaderComponent extends React.Component<IMedicalRequestHeaderComponentProps, never> {
    private id = "MedicalRequestHeaderComponent";
    private styles = cacheStore.ClinicSettings.EnableConsultationRequestWorkflowImprovements
        ? stylesImport
        : legacyStylesImport;

    public render(): JSX.Element {
        const model = this.props.model;
        if (!model)
            return null;

        return (
            <div id={this.id} className={`container-fluid ${this.styles.requestHeaderRow}`}>
                <div className="row bottom-border-light" style={{ paddingBottom: "10px", marginBottom: "10px" }}>
                    <div className="flex-container" style={{ justifyContent: "center" }}>
                        <div className="text-center">
                            <h4>{JSXHelper.getSiteDepartmentNameJSX(model.siteName, model.costCenterName)}</h4>
                            <div>
                                <span>{model.siteStreetAddress}</span>
                                {", "}
                                <span>{model.siteCity}</span>
                                {", "}
                                <span>{model.siteState}</span>
                                {", "}
                                <span>{model.siteZipCode}</span>
                                {", "}
                                <span>{model.siteCountry}</span>
                            </div>
                            <div className="prow flex-container" style={{ justifyContent: "space-evenly" }}>
                                {model.sitePhoneNumber && (
                                    <span>
                                        {cacheStore.GetString("PhoneAbbrLabel")}
                                        {model.sitePhoneNumber}
                                    </span>
                                )}
                                {model.siteFaxNumber && (
                                    <span>
                                        {cacheStore.GetString("FaxDLabel")}
                                        {model.siteFaxNumber}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row bottom-border-light" style={{ paddingBottom: "10px", marginBottom: "10px" }} data-cy={`${this.id}-patient`}>
                    <div className="row" style={{ margin: "0" }}>
                        <div className="col-xs-7">
                            <div className="row">
                                <div className="col-xs-offset-3 col-xs-8">
                                    <strong>{model.patientName}</strong>
                                </div>
                            </div>
                            {this.renderRowLiteral(sessionStore.getDefaultHealthCardLabel(), this.formattedNAM(model.patientNAM, model.patientExpiryDate))}
                            {this.renderRow("DateOfBirthAbbrNoColonLabel", model.patientDOB ? moment(model.patientDOB).format("YYYY-MM-DD") : "")}
                            {this.renderRow("SexAtBirthLabel", model.patientGender)}
                            {this.renderRow("FileNumberDLabel", model.patientFileNumber)}
                        </div>
                        <div className="col-xs-5">
                            <div className="row"><br /></div>
                            {this.renderRow("PhoneAbbrNoColonLabel", model.patientPhoneNumber)}
                            {this.renderRow("AddressLabel", model.patientStreetAddress)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderRow(label: string, content: string): JSX.Element {
        return this.renderRowLiteral(cacheStore.GetString(label), content);
    }

    private renderRowLiteral(label: string, content: string): JSX.Element {
        return (
            <div className="row" style={{ margin: "10px 0" }}>
                <div className="col-xs-5 text-right"><strong>{label}</strong></div>
                <div className="col-xs-7">{content}</div>
            </div>
        );
    }

    private formattedNAM(nam: string, expiry: Date): string {
        if (!nam)
            return "";

        if (!expiry)
            return nam;

        return `${nam} (${moment(expiry).format("YYYY-MM-DD")})`;
    }
}

export { MedicalRequestHeaderComponent };
